import { VALUES_GET_LIST,VALUES_GET_LIST_SUCCESS,VALUES_GET_LIST_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchValuesAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}OurValue/GetOurValueList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };

          
          const config_2 = {
            method: 'get',
            url: `${apiBaseUrl}OurValue/GetMaintitleList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const valuesdetails = yield axios(config).then(response => response.data.Data);
          const Maindetails = yield axios(config_2).then(response => response.data.Data);
          Maindetails.forEach(element => {
            if(element.Type === "OurValue")
            {
              //const obj = {Main_title_detail: element};
              valuesdetails.push(element);
            }
          });
        
        // console.log(subscriberDetails,"============")
        yield put({ type: VALUES_GET_LIST_SUCCESS, data: valuesdetails });
    } catch (error) {
        yield put({ type: VALUES_GET_LIST_ERROR, error });
    }
}


export function* watchValues() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(VALUES_GET_LIST, fetchValuesAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchValues),
    ]);
}